// second array value is for Biagi Brothers for testing on devlopment.
// You will have to log in as a Biago Brother user to check if it's working.
const allowedKeys = ['895a62f5-3a37-4033-be5d-84cde71c4abd']

export default allowedKeys
